// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Облік часу» (Time Tracking, ключ `tim`, група `management`). */
export const timeTrackingManifest: IModuleManifest = {
  key: 'tim',
  group: 'management',
  slug: 'time-tracking',
  prefix: 'TIM',
  name: { en: 'Time Tracking', uk: 'Облік часу' },
  entities: [
    { key: 'tim', slug: 'tim', name: { en: 'Time Tracking', uk: 'Облік часу' }, main: true },
    { key: 'time_entry_timesheet', slug: 'time-entry-timesheet', name: { en: 'Time Entry Timesheets', uk: 'Табелі' }, main: false },
    { key: 'time_entry_approval', slug: 'time-entry-approval', name: { en: 'Time Entry Approvals', uk: 'Погодження' }, main: false },
  ],
  loadState: () => import('./state/timeTrackingSlice').then((m) => m.timeTrackingSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
